module.exports = __webpack_public_path__ + "static/img/7合作伙伴.e449aa2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/关于我们/7合作伙伴.png
// module id = U8wp
// module chunks = 0